import { Chip } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";

export default function GroupChip({ groupName }: { groupName: string }) {
    return (
        <Chip variant="outlined" size="small" tw="text-gray-800 bg-white/75" label={groupName} avatar={<GroupIcon />} />
    );
}
